<template>
  <div :class="$style.box">
    <!-- 游戏模块 -->
    <div :class="$style.modal" v-for="(item, index) in gameInfo" :key="index">
      <h2>{{ item.name }}</h2>
      <div :class="$style.content" v-for="(m, i) in item.game_list" :key="`${index}-${i}`">
        <div>
          <img :src="m.icon" alt="" @click="open(m, m.id)" />
          <div>
            <h3 @click="open(m, m.id)">{{ m.title }}</h3>
            <p>{{ m.subtitle }}</p>
          </div>
          <span @click="open(m, m.id)">下载</span>
        </div>
      </div>
    </div>
    <div :class="$style.placeholder"></div>
    <!-- 查看领取奖励 -->
    <div v-if="isMine" :class="$style.check" @click="checkRecord">
      {{ '查看已领奖励>>' }}
    </div>
    <!-- 添加桌面 -->
    <div
      v-if="!isMine && isBottom == '1'"
      :class="$style.desktop"
      :style="{ backgroundImage: `url('${bottomInfo['url']}')` }"
    >
      <!-- <div @click="addDesktop">添加到桌面</div> -->
      <img @click="addDesktop" :src="btnImg" alt="">
    </div>
    <!-- 礼包码弹窗 -->
    <div :class="$style.dialog" @touchmove.prevent v-show="dialogShow">
      <div :class="$style.content">
        <div :class="$style.top" :style="{ backgroundImage: `url('${headerImg}')` }">
          <h2>
            {{
              isMine
                ? '感谢您的支持，特奉上福利好礼！'
                : '欢迎来到【变态猫游戏】，送上专属福利礼包~'
            }}
          </h2>
          <div>
            <div>礼包码：{{ isMine ? bottomInfo['gift_code'] : popInfo['gift_code'] }}</div>
            <div class="copyBtn" @click="() => {}">复制礼包码</div>
          </div>
        </div>
        <div :class="$style.bot">
          <img :src="isMine ? bannerImg : popInfo['url']" alt="" />
        </div>
      </div>
      <img :class="$style.close" :src="closeImg" @click="close" />
    </div>
    <!-- 历史记录弹窗 -->
    <div :class="$style.record" @touchmove.prevent v-show="recordShow">
      <div :class="$style.content">
        <div :class="$style.top" :style="{ backgroundImage: `url('${headerImg}')` }">已领奖励</div>
        <ul>
          <li><span>奖励名称</span><span>礼包码</span><span>操作</span></li>
          <li v-if="showPop">
            <span>新人好礼</span>
            <span>{{ popInfo['gift_code'] }}</span>
            <span><span class="copyBtn2" @click="() => {}">复制</span></span>
          </li>
          <li v-if="showBot">
            <span>添加桌面奖励</span>
            <span>{{ bottomInfo['gift_code'] }}</span>
            <span><span class="copyBtn3" @click="() => {}">复制</span></span>
          </li>
        </ul>
      </div>
      <img :class="$style.close" :src="closeImg" @click="recordShow = false" />
    </div>
    <!-- 引导图片 -->
    <div
      v-show="deskShow"
      :class="$style.desk"
      :style="{ backgroundImage: `url('${deskImg}')` }"
      @touchmove.prevent
    >
      <img :src="innerCloseImg" alt="" @click="deskShow = false" />
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { channelGame, reportWebsiteData } from '@/api/preview';
import { CDN_URL } from '@/config/index.js';

export default {
  data() {
    return {
      gameInfo: [], // 列表信息
      isPop: 0, // 弹窗状态 1正常 2隐藏
      isBottom: 0, // 底部状态 1正常 2隐藏
      bottomInfo: {}, // 底栏信息
      popInfo: {}, // 弹窗信息
      dialogShow: false, // 礼包弹窗显示
      headerImg: `${CDN_URL}/996_header.png`,
      closeImg: `${CDN_URL}/996_close.png`,
      bannerImg: `${CDN_URL}/996_banner.jpg?v=123`,
      deskImg: `${CDN_URL}/996_desktop.png?v=1`,
      innerCloseImg: `${CDN_URL}/close.png`,
      btnImg: `${CDN_URL}/996_btn.png`,
      isMine: false, // 判断是否是自己的包里
      recordShow: false, // 记录是否显示
      showBot: false,
      showPop: false,
      isWX: false, // 是否为微信浏览器 - 用于【添加到桌面】
      downloadUrl: '', // 添加到桌面地址
      ua: '', // 设备信息
      imei: '', // imei
      deskShow: false,
    };
  },
  created() {
    window.document.title = '变态猫游戏-变态传奇品牌推荐';
  },
  computed: {
    // 帖子id
    channelID() {
      return this.$route.query.channel_id;
    },
  },
  mounted() {
    this.copyInit();
    this.$nextTick(() => {
      window.addEventListener('load', () => {
        this.getChannelGame({ channel_id: this.channelID });
        this.reportWebsiteData({ data_type: 1 });
      });
    });
  },
  methods: {
    // 点击添加到桌面
    addDesktop() {
      this.reportWebsiteData({ data_type: 4 });
      this.isWX ? (this.deskShow = true) : window.open(this.downloadUrl, '_blank');
    },
    // 初始化
    initData() {
      // 判断设备
      if (window.Android) {
        this.isMine = true;
        const info = window.Android.getInfo();
        const infoJSON = JSON.parse(info);
        this.imei = infoJSON.imei === 'unknown' ? infoJSON.oaid : infoJSON.imei;
      }
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      this.ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      this.isWX = this.ua.match(/MicroMessenger/i) == 'micromessenger';
      // 判断是否已经领取
      const botcopy = localStorage && localStorage.getItem('botcopy');
      const popcopy = localStorage && localStorage.getItem('popcopy');
      if (this.isMine && botcopy !== '1') {
        this.dialogShow = this.isBottom == '1' ? true : false;
        this.showPop = this.isPop == '1' ? true : false;
        this.showBot = false;
      } else if (this.isMine && botcopy === '1') {
        this.dialogShow = false;
        this.showBot = this.isBottom == '1' ? true : false;
        this.showPop = this.isPop == '1' ? true : false;
      }
      if (!this.isMine && popcopy !== '1') {
        this.dialogShow = this.isPop == '1' ? true : false;
        this.showPop = false;
      } else if (!this.isMine && popcopy === '1') {
        this.dialogShow = false;
        this.showPop = this.isPop == '1' ? true : false;
      }
    },
    // 复制
    copyInit() {
      // 礼包领取成功弹窗中点击复制
      this.copy = new Clipboard('.copyBtn', {
        text: () => {
          return this.isMine ? this.bottomInfo['gift_code'] : this.popInfo['gift_code'];
        },
      });
      this.copy.on('success', (e) => {
        if (this.isMine) {
          localStorage.setItem('botcopy', '1');
          this.reportWebsiteData({ data_type: 8 });
        } else {
          localStorage.setItem('popcopy', '1');
          this.reportWebsiteData({ data_type: 5 });
        }
        this.$toast('礼包码复制成功～');
        this.initData();
      });
      this.copy2 = new Clipboard('.copyBtn2', {
        text: () => {
          return this.popInfo['gift_code'];
        },
      });
      this.copy2.on('success', (e) => {
        this.$toast('礼包码复制成功～');
      });
      this.copy3 = new Clipboard('.copyBtn3', {
        text: () => {
          return this.bottomInfo['gift_code'];
        },
      });
      this.copy3.on('success', (e) => {
        this.$toast('礼包码复制成功～');
      });
    },
    open(item, id) {
      this.reportWebsiteData({ data_type: 2, channel_game_id: id });
      window.open(item.url, '_blank');
    },
    close() {
      this.dialogShow = false;
      this.reportWebsiteData({ data_type: 6 });
    },
    checkRecord() {
      this.recordShow = true;
      this.reportWebsiteData({ data_type: 7 });
    },
    async getChannelGame(params) {
      const r = await channelGame(params);
      if (r.code !== 1) return;
      this.gameInfo = r.data.bord_list; // 列表信息
      this.isPop = r.data.channel.is_pop;
      this.isBottom = r.data.channel.is_bottom;
      this.bottomInfo = r.data.channel.bottom;
      this.popInfo = r.data.channel.pop;
      this.downloadUrl = r.data.channel.download_url;
      this.initData();
    },
    // 埋点
    async reportWebsiteData(data) {
      const params = {
        type: 16,
        channel_id: this.channelID,
        ua: this.ua,
        imei: this.imei,
        ...data,
      };
      await reportWebsiteData(params);
    },
  },
};
</script>

<style lang='scss' module>
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-x: hidden;
  .modal {
    width: 100%;
    min-height: 130px;
    padding: 10px 0px;
    > h2 {
      width: 100%;
      text-align: center;
      height: 30px;
      line-height: 30px;
      font-size: 20px;
      font-weight: bold;
    }
    .content {
      width: 100%;
      height: 80px;
      // margin-bottom: 5px;
      // border-bottom: 0.5px solid #ccc;
      box-shadow: 0px 1px 1px -1px #ccc;
      > div {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 10px;
        align-items: center;
        > img {
          flex: none;
          width: 60px;
          height: 60px;
          border-radius: 10px;
          margin-right: 6px;
        }
        > div {
          flex: 1;
          margin-right: 6px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          > h3 {
            width: 100%;
            line-height: 20px;
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 4px;
          }
          > p {
            font-size: 13px;
            color: #c1c1c1;
          }
        }
        > span {
          flex: none;
          width: 60px;
          background-color: #ff8500;
          height: 24px;
          border-radius: 14px;
          line-height: 24px;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
  .placeholder {
    width: 100%;
    height: 50px;
  }
  .check {
    position: fixed;
    right: 0;
    top: 30px;
    width: 120px;
    line-height: 25px;
    font-size: 14px;
    text-align: center;
    background-color: #4bd174;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    color: #fff;
    z-index: 6;
  }
  .desktop {
    width: 100%;
    height: 70px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 6;
    background-repeat: no-repeat;
    background-size: cover;
    > img {
      width: 100px;
      position: absolute;
      right: 10px;
      top: 20px;
    }
    > div {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      background: #60a8e6;
      border-radius: 4px;
      background-color: #60a8e6;
      position: absolute;
      right: 10px;
      top: 20px;
    }
  }

  .dialog {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .content {
      width: 300px;
      height: 280px;
      background-color: #fff;
      border-radius: 10px;
      margin: 180px auto;
      .top {
        width: 100%;
        height: 102px;
        background-size: cover;
        background-repeat: no-repeat;
        overflow: hidden;
        h2 {
          width: 100%;
          text-align: center;
          line-height: 23px;
          color: #fff;
          font-weight: bold;
          font-size: 14px;
          margin-top: 16px;
        }
        > div {
          width: 100%;
          height: 31px;
          display: flex;
          justify-content: space-between;
          padding: 0px 26px;
          margin-top: 12px;
          > div:nth-child(1) {
            width: 165px;
            height: 31px;
            border-radius: 20px;
            background-color: #fff;
            padding-left: 14px;
            line-height: 31px;
            font-size: 12px;
          }
          > div:nth-child(2) {
            width: 78px;
            height: 31px;
            text-align: center;
            line-height: 31px;
            color: #fff;
            background-color: #f86307;
            border-radius: 20px;
            font-size: 12px;
          }
        }
      }
      .bot {
        width: 293px;
        height: 171px;
        margin: 4px auto 0px auto;
        border-radius: 10px;
        > img {
          width: 100%;
          height: 171px;
          border-radius: 10px;
        }
      }
    }
    .close {
      width: 26px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 470px;
    }
  }

  .record {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .close {
      width: 26px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 470px;
    }
    .content {
      width: 300px;
      height: 280px;
      background-color: #fff;
      border-radius: 10px;
      margin: 180px auto;
      .top {
        width: 100%;
        height: 40px;
        background-size: cover;
        background-repeat: no-repeat;
        overflow: hidden;
        text-align: center;
        line-height: 40px;
        color: #fff;
        font-weight: bold;
        font-size: 16px;
      }
      > ul {
        width: 100%;
        height: 240px;
        > li {
          width: 100%;
          height: 34px;
          line-height: 34px;
          background-color: rgba(238, 238, 238, 0.38);
          margin-bottom: 1px;
          display: flex;
          text-align: center;
          font-size: 10px;
          > span:nth-child(1) {
            color: #ffb531;
            flex: 0.3;
          }
          > span:nth-child(2) {
            flex: 0.4;
            color: #999999;
          }
          > span:nth-child(3) {
            flex: 0.3;
            > span {
              display: inline-block;
              width: 41px;
              height: 16px;
              border-radius: 10px;
              text-align: center;
              line-height: 16px;
              color: #fff;
              background-color: #ff8500;
            }
          }
        }
        > li:nth-child(1) {
          background-color: #eee;
          color: #a1a1a1;
          font-size: 13px;
          > span:nth-child(1) {
            color: #666666;
          }
          > span:nth-child(2) {
            color: #666666;
          }
          > span:nth-child(3) {
            color: #666666;
          }
        }
      }
    }
  }

  .desk {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 20;
    background-repeat: no-repeat;
    background-size: 100%;
    > img {
      width: 24px;
      position: absolute;
      top: 10px;
      left: 10px;
    }
  }
}
</style>